__turbopack_context__.v({
  "actionMeta": "Layout-module__HavBlW__actionMeta",
  "actionsContainer": "Layout-module__HavBlW__actionsContainer",
  "alignImages": "Layout-module__HavBlW__alignImages",
  "amountBifur": "Layout-module__HavBlW__amountBifur",
  "categoryIcon": "Layout-module__HavBlW__categoryIcon",
  "center_align": "Layout-module__HavBlW__center_align",
  "cgEditAmoutBox": "Layout-module__HavBlW__cgEditAmoutBox",
  "cgLargebtn": "Layout-module__HavBlW__cgLargebtn",
  "cgLargebtnDestop": "Layout-module__HavBlW__cgLargebtnDestop",
  "cgbtn": "Layout-module__HavBlW__cgbtn",
  "cghalftextbox": "Layout-module__HavBlW__cghalftextbox",
  "cgtextbox": "Layout-module__HavBlW__cgtextbox",
  "cgtextboxDesktop": "Layout-module__HavBlW__cgtextboxDesktop",
  "cgtextboxDisabled": "Layout-module__HavBlW__cgtextboxDisabled",
  "chipContainer": "Layout-module__HavBlW__chipContainer",
  "confirmationBtn": "Layout-module__HavBlW__confirmationBtn",
  "confirmationPrimary": "Layout-module__HavBlW__confirmationPrimary",
  "confirmationSecondary": "Layout-module__HavBlW__confirmationSecondary",
  "confirmationText": "Layout-module__HavBlW__confirmationText",
  "copyIconStyle": "Layout-module__HavBlW__copyIconStyle",
  "createAccount": "Layout-module__HavBlW__createAccount",
  "createAccountAction": "Layout-module__HavBlW__createAccountAction",
  "createAccountActionOtp": "Layout-module__HavBlW__createAccountActionOtp",
  "createAccountContainer": "Layout-module__HavBlW__createAccountContainer",
  "deepLinkLanding": "Layout-module__HavBlW__deepLinkLanding",
  "disabledResendButton": "Layout-module__HavBlW__disabledResendButton",
  "dummyImage": "Layout-module__HavBlW__dummyImage",
  "feedbackbtn": "Layout-module__HavBlW__feedbackbtn",
  "fixedHeight": "Layout-module__HavBlW__fixedHeight",
  "fixpageLayout": "Layout-module__HavBlW__fixpageLayout",
  "heading": "Layout-module__HavBlW__heading",
  "inLineAction": "Layout-module__HavBlW__inLineAction",
  "info_compoent": "Layout-module__HavBlW__info_compoent",
  "info_compoent_icon": "Layout-module__HavBlW__info_compoent_icon",
  "info_compoent_text": "Layout-module__HavBlW__info_compoent_text",
  "labelCtaWrapper": "Layout-module__HavBlW__labelCtaWrapper",
  "loginInputBox": "Layout-module__HavBlW__loginInputBox",
  "logoutButtonContainer": "Layout-module__HavBlW__logoutButtonContainer",
  "nameWrapper": "Layout-module__HavBlW__nameWrapper",
  "optionLabel": "Layout-module__HavBlW__optionLabel",
  "pageBackground": "Layout-module__HavBlW__pageBackground",
  "pageContainer": "Layout-module__HavBlW__pageContainer",
  "pageDiv": "Layout-module__HavBlW__pageDiv",
  "pageLayout": "Layout-module__HavBlW__pageLayout",
  "pageTitle": "Layout-module__HavBlW__pageTitle",
  "paymentProgressText": "Layout-module__HavBlW__paymentProgressText",
  "paymentProgressingWrapper": "Layout-module__HavBlW__paymentProgressingWrapper",
  "paymentStatusImage": "Layout-module__HavBlW__paymentStatusImage",
  "paymentStatusInfo": "Layout-module__HavBlW__paymentStatusInfo",
  "paymentStatusText": "Layout-module__HavBlW__paymentStatusText",
  "profileInputFieldWrapper": "Layout-module__HavBlW__profileInputFieldWrapper",
  "profileUpdateCtas": "Layout-module__HavBlW__profileUpdateCtas",
  "recentTransactionCTA": "Layout-module__HavBlW__recentTransactionCTA",
  "right_items": "Layout-module__HavBlW__right_items",
  "subHeading": "Layout-module__HavBlW__subHeading",
  "tagLine": "Layout-module__HavBlW__tagLine",
  "upiAppsLayout": "Layout-module__HavBlW__upiAppsLayout",
  "upiLandingHeight": "Layout-module__HavBlW__upiLandingHeight",
  "upiRegisteredName": "Layout-module__HavBlW__upiRegisteredName",
  "upiqrLayout": "Layout-module__HavBlW__upiqrLayout",
  "userActions": "Layout-module__HavBlW__userActions",
});
